import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import styles from './AggregateConflictToolbar.module.css'
import { callFunctionConditionallyWithWarningCurry } from '../../utils/utils'
import DatePicker from '../DatePicker/DatePicker';
import { Prompt } from 'react-router-dom';
import { DISPLAY_MESSAGES } from '../../constants';

const AggregateConflictToolbar = ({
  lastRefreshedDate,
  startDate,
  hasActiveEdits,
  activeAsnDate,
  handleDateSelect,
  restrictNavigationDuringEditing
}) => {
  return (
    <div className={styles.RgtTools}>
      <span className={styles.captionSmallBt}>
        {lastRefreshedDate
          ? `Last Refreshed: ${lastRefreshedDate.format(
              'hh:mmA [(IST)] DD MMMM YYYY',
            )}`
          : 'Last Refreshed: --:--'}
      </span>

<div className={styles.aggregateToolbar} data-testid="aggregateToolbar">
  <div className={styles.datesSelectorBar} data-testid="datesSelectorBar">
    {startDate && (
      <DatePicker
        startDate={moment(startDate)}
        endDate={moment(startDate).add(15, 'days')}
        activeDate={activeAsnDate}
        handleSelectedDate={callFunctionConditionallyWithWarningCurry(
          handleDateSelect,
          hasActiveEdits
        )}
        datePickerMonthPreFix="Chassis Line -"
      />
    )}
  </div>
</div>

      {restrictNavigationDuringEditing && (
        <Prompt
          when={hasActiveEdits}
          message={() => DISPLAY_MESSAGES.NAVIGATION_WARNING}
        />
      )}
    </div>
  );
};

AggregateConflictToolbar.propTypes = {
  lastRefreshedDate: PropTypes.objectOf(moment).isRequired,
  startDate: PropTypes.string.isRequired,
  hasActiveEdits: PropTypes.bool.isRequired,
  activeAsnDate: PropTypes.objectOf(moment).isRequired,
  handleDateSelect: PropTypes.func.isRequired,
  restrictNavigationDuringEditing: PropTypes.bool
}

export default AggregateConflictToolbar